Apt.fn.make('account.messages', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 */
	init(options) {
		const scope = this;
		const $target = $$('messages');

		let path;

		options = Object.assign({
			empty: "You haven't delivered any messages yet.",
			path: 'me',
			sender: false,
			static: false,
			target: true
		}, options);

		path = options.path;

		if (path) {
			path += '/';
		}

		scope.app = Apt.fn.index().init({
			auth: true,
			target: $target,
			view: 'account-messages.results',
			event: options.static !== true ?
				'push' : false,
			path: 'account/messages',
			resource: `${path}messages`,
			paginate: true,
			static: options.static === true,
			filters: options.filters || {},
			params: Object.assign({
				limit: 10,
				sort: '-newest'
			}, options.params),
			model: {
				empty: options.empty,
				sender: options.sender,
				target: options.target
			},
			transform: message => {
				message.created_at = LS.util.localize(message.created_at)
					.toISOString();
			}
		});

		return scope;
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('messages', this, 'app');
	}
});